export enum PolicyStatus {
    NotStarted,
    Active,
    Completed
}
